import baseApi from "src/config/api/base"
import { ApplyRequest, ApplyResponse, ResendOtpRequest, ResendOtpResponse } from "./types/apply"
import { Apply2Request, Apply2Response } from "./types/apply2"
import { Apply3Request, Apply3Response } from "./types/apply3"
import { BaseResponse } from "./types/common"
import { GetCaptcha1Response, GetCaptcha1Request } from "./types/captcha"
import { GetConfigListRequest, GetConfigListResponse } from "./types/configList"

const functionCode = "SPE0009"
const errorCounter = "3"
const lockHours = "24"

const api = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getTokenByTckn1: builder.mutation<BaseResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body,
          functionCode: functionCode,
          NextTransactionUrl: "Facebook/SocialMediaPortalCreateSession/GetTokenByTckn1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF",
        },
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getConfigList: builder.mutation<GetConfigListResponse, GetConfigListRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          functionCode: "SPE0009",
          cid: body.cid,
          NextTransactionUrl: "Facebook/SMPUConfig/GetConfigListWithFunctionCode1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF",
        },
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getCaptcha: builder.mutation<GetCaptcha1Response, GetCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/GenclikBankaciligi/GetCaptcha1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    refreshCaptcha: builder.mutation<GetCaptcha1Response, GetCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/GenclikBankaciligi/RefreshCaptcha1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply: builder.mutation<ApplyResponse, ApplyRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          dogumGun: body.dogumGun,
          dogumAy: body.dogumAy,
          dogumYil: body.dogumYil,
          cepTel: body.cepTel,
          captcha: body.captcha,
          kvkk: body.kvkk,
          ageConfirmation: body.ageConfirmation,
          cid: body.cid,
          appCode: functionCode,
          errorCount: errorCounter,
          lockHours: lockHours,
          NextTransactionUrl: "Facebook/GenclikBankaciligi/Apply1",
          TokenSessionId: body.TokenSessionId,
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    resendOtp: builder.mutation<ResendOtpResponse, ResendOtpRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          NextTransactionUrl: "Facebook/GenclikBankaciligi/ResendOtp1",
          TokenSessionId: body.TokenSessionId,
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply2: builder.mutation<Apply2Response, Apply2Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          otp: body.otp,
          NextTransactionUrl: "Facebook/GenclikBankaciligi/Apply2",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply3: builder.mutation<Apply3Response, Apply3Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          kimlikSeriSiraNo: body.kimlikSeriSiraNo,
          appCode: functionCode,
          errorCount: errorCounter,
          lockHours: lockHours,
          NextTransactionUrl: "Facebook/GenclikBankaciligi/Apply3",
          TokenSessionId: body.TokenSessionId,

        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    })
  })
})

export const { useGetTokenByTckn1Mutation, useGetConfigListMutation, useGetCaptchaMutation, useRefreshCaptchaMutation, useApplyMutation, useResendOtpMutation, useApply2Mutation, useApply3Mutation } = api

export default api
